import { render, staticRenderFns } from "./DetailModal.vue?vue&type=template&id=77d69130&scoped=true"
import script from "./DetailModal.vue?vue&type=script&lang=js"
export * from "./DetailModal.vue?vue&type=script&lang=js"
import style0 from "./DetailModal.vue?vue&type=style&index=0&id=77d69130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d69130",
  null
  
)

export default component.exports